import { UserServiceClient } from 'fitbeat.api-clients';
import { ProcessTypes, UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import { inviteScreenUnmounted } from '../../Planner/plannerActions';
import { selectWorkoutInviteId } from '../../Planner/plannerSelectors';
import { clearDeepLinkParams } from '../../utils/notifications/actions';
import { acceptInvite, getNextBookingStep, setWorkoutSession } from '../actions';
import { OpenInvite } from '../components';

interface IProps {
  userProfile: UserProfile;
  workoutInviteId: string;
  loadingWorkoutSessions: boolean;
  signupWorkoutInviteId: string | undefined;
  userServiceClient: UserServiceClient;
  t(key: string): string;
  closeModal(): void;
  getNextBookingStep(userProfile: UserProfile, processType: ProcessTypes): void;
  clearDeepLinkParams(keys: string[]): void;
  setWorkoutSession(workoutSession: UserWorkoutSession): void;
  acceptInvite(workoutSession: UserWorkoutSession): void;
  inviteScreenUnmounted: () => void;
}
class OpenInviteReceived extends Component<IProps> {
  componentWillUnmount(): void {
    this.props.inviteScreenUnmounted();
    this.props.clearDeepLinkParams(['workoutInviteId', 'workoutInviteStartTime', 'influencerId']);
  }

  public acceptOpenInvite = async (userWorkoutSession) => {
    const { userProfile, getNextBookingStep, setWorkoutSession } = this.props;
    setWorkoutSession(userWorkoutSession);
    getNextBookingStep(userProfile, ProcessTypes.BookingMade);
    this.props.acceptInvite(userWorkoutSession);
  }

  public ignoreOpenInvite = async () => {
    const { userProfile, getNextBookingStep, closeModal } = this.props;
    getNextBookingStep(userProfile, ProcessTypes.Cancel);
    closeModal();
  }

  public render() {
    const { workoutSessionService, closeModal, userProfile, workoutInviteId} = this.props;
    return (
      <View style={styles.container}>
        <OpenInvite
          theme='light'
          workoutInviteId={workoutInviteId}
          onCompleteAcceptInvite={this.acceptOpenInvite}
          ignoreInvite={this.ignoreOpenInvite}
          workoutSessionService={workoutSessionService}
          closeModal={closeModal}
          userProfile={userProfile}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

const mapStateToProps = (state, props) => {
  const workoutInviteId = selectWorkoutInviteId(state);
  return {
    workoutInviteId,
    userServiceClient: props.userProfileService.userServiceClient,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearDeepLinkParams: (keysToClear) => dispatch(clearDeepLinkParams(keysToClear)),
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
    setWorkoutSession: (workoutSession) => dispatch(setWorkoutSession(workoutSession)),
    acceptInvite: (workoutSession) => dispatch(acceptInvite(workoutSession)),
    inviteScreenUnmounted : () => dispatch(inviteScreenUnmounted())
  };
};

export const OpenInviteReceivedStep = connect(mapStateToProps, mapDispatchToProps)(OpenInviteReceived);
